var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefrigeratorRound695Svgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0833 5.90059C11.0833 6.46178 10.6278 6.91724 10.0666 6.91724C9.50541 6.91724 9.04995 6.46178 9.04995 5.90059C9.04995 5.3394 9.50541 4.88394 10.0666 4.88394C10.6278 4.88394 11.0833 5.3394 11.0833 5.90059ZM11.0833 12.0005C11.0833 12.5617 10.6278 13.0171 10.0666 13.0171C9.50541 13.0171 9.04995 12.5617 9.04995 12.0005C9.04995 11.4393 9.50541 10.9838 10.0666 10.9838C10.6278 10.9838 11.0833 11.4393 11.0833 12.0005ZM8.0333 7.93389V4.88394C8.0333 4.32274 8.48876 3.86729 9.04995 3.86729H15.1499C15.711 3.86729 16.1665 4.32274 16.1665 4.88394V7.93389H8.0333ZM15.1499 18.1004H9.04995C8.48876 18.1004 8.0333 17.6449 8.0333 17.0837V9.96719H16.1665V17.0837C16.1665 17.6449 15.711 18.1004 15.1499 18.1004ZM8.0333 1.83398C6.9099 1.83398 6 2.74389 6 3.86729V7.93389V9.96719V18.1004C6 19.2238 6.9099 20.1337 8.0333 20.1337V21.1503C8.0333 21.7115 8.48876 22.167 9.04995 22.167C9.61114 22.167 10.0666 21.7115 10.0666 21.1503V20.1337H14.1332V21.1503C14.1332 21.7115 14.5887 22.167 15.1499 22.167C15.711 22.167 16.1665 21.7115 16.1665 21.1503V20.1337C17.2899 20.1337 18.1998 19.2238 18.1998 18.1004V9.96719V7.93389V3.86729C18.1998 2.74389 17.2899 1.83398 16.1665 1.83398H8.0333Z",
    fill: "#9393B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigeratorRound695Svgrepocom);
export default __webpack_public_path__ + "static/media/refrigerator-round-695_svgrepo.com.a9b3b415889a6f258d6095b7a41373a9.svg";
export { ForwardRef as ReactComponent };